import React, { FC } from 'react'

import TabPageHeader from '../TabPageHeader'

export interface ExecutiveSummaryHeaderProps {
  inEditMode?: boolean
  onEditClick?: () => void
  isEditingPlan?: boolean
  onClientPdfClick?: () => void
  isGeneratingPdf?: boolean
  onAllClientPdfsClick?: () => void
  onAllStaffPdfsClick?: () => void
  staffPdfDisabledReason?: string
  pageTitle?: string
  onEditPageTitle?: () => void
  showActions?: boolean
}

const ExecutiveSummaryHeader: FC<ExecutiveSummaryHeaderProps> = ({ inEditMode = false, onEditClick, isEditingPlan = false, onClientPdfClick, isGeneratingPdf = false, onAllClientPdfsClick, onAllStaffPdfsClick, staffPdfDisabledReason, pageTitle, onEditPageTitle, showActions = false }) => {
  const displayTitle = pageTitle || 'Executive Summary'
  return <TabPageHeader title={displayTitle} inEditMode={inEditMode} onEditClick={onEditClick} isEditingPlan={isEditingPlan} onClientPdfClick={onClientPdfClick} isGeneratingPdf={isGeneratingPdf} onAllClientPdfsClick={onAllClientPdfsClick} onAllStaffPdfsClick={onAllStaffPdfsClick} staffPdfDisabledReason={staffPdfDisabledReason} onEditPageTitle={showActions ? onEditPageTitle : undefined} />
}

export default ExecutiveSummaryHeader
